import { useState, useEffect } from 'react'
import { PageLayout } from '@/components/layout'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useMarketEvents } from '@/hooks/useMarketEvents'
import { useSquareSync } from '@/hooks/useSquareSync'
import MarketEventsList from '@/components/markets/MarketEventsList'
import SquareConnectionCard from '@/components/markets/SquareConnectionCard'
import SquareProductMappings from '@/components/markets/SquareProductMappings'

export default function MarketsPage({ user, onLogout }) {
  const { events, loading, refresh } = useMarketEvents()
  const { getConnectionStatus } = useSquareSync()
  const [connection, setConnection] = useState(null)

  useEffect(() => {
    getConnectionStatus().then(setConnection)
  }, [getConnectionStatus])

  return (
    <PageLayout user={user} onLogout={onLogout}>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Markets</h1>
          <p className="text-muted-foreground mt-1">
            Market events, Square POS sync, and profitability tracking
          </p>
        </div>

        <Tabs defaultValue="events">
          <TabsList>
            <TabsTrigger value="events">Events</TabsTrigger>
            <TabsTrigger value="settings">Settings</TabsTrigger>
          </TabsList>

          <TabsContent value="events" className="mt-4">
            <MarketEventsList
              events={events}
              loading={loading}
              onRefresh={refresh}
              isConnected={!!connection}
            />
          </TabsContent>

          <TabsContent value="settings" className="mt-4 space-y-6">
            <SquareConnectionCard
              connection={connection}
              onConnectionChange={() => getConnectionStatus().then(setConnection)}
            />
            {connection && (
              <SquareProductMappings />
            )}
          </TabsContent>
        </Tabs>
      </div>
    </PageLayout>
  )
}
